export default "__VITE_ASSET__NPTOuTmE__"